import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen';
import { faXmark } from '@fortawesome/pro-light-svg-icons/faXmark';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { Input } from 'ui-components/components/input';
import { Button } from 'ui-components/components/button';
import { FormattedExportHeader } from './formatted-export-header';

import style from '../export-records-modal.module.less';

export const SelectedFieldListItem = ({ classNames = '', fieldName, fieldId, onClick, editFieldName, modifiedFieldName }) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [inputValue, setInputValue] = useState(modifiedFieldName || '');
  const onEditClick = (e) => {
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    setIsEditOpen(!isEditOpen);
  };
  const onTextInputChange = (value) => setInputValue(value);
  const cancelEditFieldName = () => {
    setIsEditOpen(false);
    setInputValue(modifiedFieldName || '');
  };
  const onSubmitButtonClick = () => {
    setIsEditOpen(false);
    editFieldName(fieldId, inputValue);
  };
  const isModified = fieldName !== fieldId;
  const hasInputValue = inputValue && inputValue.length;
  return (
    <li className={classNames}>
      <div className={style['selected-field-name']} onClick={() => onClick(fieldId)}>
        <FormattedExportHeader fieldId={fieldId} fieldName={fieldName} />
        <div onClick={onEditClick}>
          <FontAwesomeIcon className={style['edit-svg']} icon={faPen} />
        </div>
      </div>
      {isEditOpen && (
        <div className={style['edit-field-name']}>
          <Input onChange={onTextInputChange} value={inputValue} />
          <Button
            className={classnames(style['save-column-button'], {
              [style.disabled]: !hasInputValue,
            })}
            disabled={!hasInputValue}
            onClick={onSubmitButtonClick}
            theme='unstyled'
          >
            <FormattedMessage defaultMessage='Save' description='customExports.saveButton' id='8Q1EgO' />
          </Button>
          <Button className={style['remove-button']} onClick={cancelEditFieldName} theme='unstyled'>
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        </div>
      )}
      {isModified && (
        <span className={style['original-field-name']}>
          <FormattedExportHeader fieldId={fieldId} />
        </span>
      )}
    </li>
  );
};

SelectedFieldListItem.propTypes = {
  classNames: PropTypes.string,
  fieldName: PropTypes.string.isRequired,
  fieldId: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  editFieldName: PropTypes.func.isRequired,
  modifiedFieldName: PropTypes.string,
};
